export enum SortError {
    NumberOfColumnsNotEqual = 'NumberOfColumnsNotEqual',
    PrioritiesNotEqual = 'PrioritiesNotEqual',
    NoProblem = 'NoProblem'
  }
  